import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import keycloak from '../../../common/Keycloak';
import PageTracker from '../../../common/PageTrackerHelper';

export default {
  name: 'kavachlogin',
  components: { VueElementLoading },
  props: [],
  mixins:[PageTracker],
  data() {
    return {
      username: '',
      password: '',
      tokenId: '',
      isLoading: false,
    }
  },
  mounted() {
    this.checklogin();
  },
  methods: {
    checklogin() {
      this.isLoading = true;
      axios.post(apiUrl.api_url + 'user/authorizations', {
        'appName': 'B2C Express'
      }).then(async(response) => {
        if (response.data.code == 200) {
          let userKey = await this.generateEncryptDecryptKey();
          window.localStorage.setItem('userUniqueKey',userKey);
          let permissionEncrypt = CryptoJS.AES.encrypt(JSON.stringify(response.data.data.access), userKey);
          let usersEncrupt = CryptoJS.AES.encrypt(JSON.stringify(response.data.data), userKey);
          window.localStorage.setItem('lmaccesspermissiondata', permissionEncrypt);
          window.localStorage.setItem('lmaccessuserdata', usersEncrupt);
          window.localStorage.setItem('isLoggedIn', true);
          // window.localStorage.setItem('lmUserToken',response.data.lmUserToken)
          // response.data.isLoginAuthCheck = true; //****** REMOVE THIS LINE ******///.
          window.localStorage.setItem('isLoginAuthCheck', response.data.isLoginAuthCheck);
          // if(response.data.isLoginAuthCheck &&  response.data.refreshToken.trim() != '') {
          //   window.localStorage.setItem('refreshToken',response.data.refreshToken);
          // }
          window.localStorage.setItem('missinghubids',"");
          window.localStorage.setItem('onepagerprintflag',"New");
          permissionEncrypt = window.localStorage.getItem('lmaccesspermissiondata');
          let permissiondatabytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), userKey);
          let permissiondataplaintext = permissiondatabytes.toString(CryptoJS.enc.Utf8);
          let permissiondata = JSON.parse(permissiondataplaintext);
          let printRoute = window.localStorage.getItem('printRoute');
          if(printRoute){
            this.$router.push(printRoute);
          }else{
            this.$router.push(permissiondata[0].url);
          }
          this.$alertify.success('Successfully logged in.!');
        } else {
          this.isLoading = false;
          this.$alertify.error(response.data.message);
          setTimeout(() => {
            keycloak.logoutWithTokenId();
          }, 1000);
        }
        this.isLoading = false;
      }).catch((httpException) => {
        this.isLoading = false;
        this.$alertify.error("Logging Failed");
        console.error('exception is:::::::::', httpException)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/kavachLogin/kavachlogin.component.js